import React from 'react'
import Svg from './..'

export interface ExclamationWithCircleProps
  extends React.SVGProps<SVGSVGElement> {
  children: React.ReactNode
}

const ExclamationWithCircle = ({
  className,
  ...restProps
}: ExclamationWithCircleProps) => {
  return (
    <Svg
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...restProps}
    >
      <path
        d='M10.6612 8.66399L10.6612 5.64665C10.6612 5.19131 10.292 4.82219 9.83671 4.82219C9.38137 4.82219 9.01225 5.19132 9.01225 5.64665L9.01228 8.66399L9.0123 11.843C9.0123 12.2982 9.38135 12.6673 9.83659 12.6673C10.2918 12.6673 10.6608 12.2983 10.6609 11.8431L10.6612 8.66399Z'
        fill='#E65156'
      />
      <path
        d='M9.94025 13.8876L9.76262 13.8876C9.35638 13.8876 9.02711 14.217 9.02727 14.6233C9.02725 15.0514 9.37433 15.3985 9.80249 15.3985L9.9005 15.3985C10.3287 15.3985 10.6759 15.0515 10.6762 14.6233C10.676 14.2169 10.3466 13.8876 9.94025 13.8876Z'
        fill='#E65156'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 5.16751 14.8325 1.25 10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.8325 5.16751 18.75 10 18.75ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z'
        fill='#E65156'
      />
    </Svg>
  )
}

export default ExclamationWithCircle
